export type SectionId = 'home' | 'stats' | 'hideout' | 'inventory' | 'loadout' | 'codex' | 'sectors' | 'settings';

export type SectionDef = {
  id: SectionId;
  icon: string;
  labelKey:
    | 'section.home'
    | 'section.stats'
    | 'section.hideout'
    | 'section.inventory'
    | 'section.loadout'
    | 'section.codex'
    | 'section.sectors'
    | 'section.settings';
};

export const SECTIONS: ReadonlyArray<SectionDef> = [
  { id: 'home',      icon: '🏠', labelKey: 'section.home' },
  { id: 'stats',     icon: '📊', labelKey: 'section.stats' },
  { id: 'hideout',   icon: '🛰️', labelKey: 'section.hideout' },
  { id: 'sectors',   icon: '🗺',  labelKey: 'section.sectors' },
  { id: 'inventory', icon: '🎒', labelKey: 'section.inventory' },
  { id: 'loadout',   icon: '🧬', labelKey: 'section.loadout' },
  { id: 'codex',     icon: '📜', labelKey: 'section.codex' },
  { id: 'settings',  icon: '⚙',  labelKey: 'section.settings' },
];
